<script lang="ts">

    import {platform} from "../store/store";
    import {BigCommerceAddToCart, ShopifyAddToCart} from "@fast-simon/add-to-cart";
    import {ServerProduct} from "../@types/product";

    export let id: string;
    export let product: ServerProduct;

    let addToCartText = 'Add to Cart';
    let soldOutText = 'Sold Out';

    const setStatus = (status: string) => {
        addToCartText = status + (status === 'Adding' ? '...' : status === 'Added' ? '!' : '');
        if (['Added!', 'Error'].includes(addToCartText)) {
            setTimeout(() => {
                addToCartText = 'Add to Cart';
            }, 1000);
        }
    }

    const onClick = (event) => {
        if(product?.iso) {
            return;
        }
        if($platform === 'Shopify') {
            let addToCartObj = new ShopifyAddToCart('fast-simon-upsell');
            addToCartObj.addToCart(product?.s, setStatus, id, 1);
        } else if ($platform === 'BigCommerce') {
            let addToCartObj = new BigCommerceAddToCart('fast-simon-upsell');
            addToCartObj.addToCart(String(id), setStatus, undefined, 1);
        }
    }

</script>

<div class="fast-upsell-btn-container upsell-btn-container" class:fs-atc-so={product?.iso} on:click|stopPropagation|preventDefault={onClick}>
    <div class="fast-add-to-cart-button-upsell add-to-cart-button-upsell">{product?.iso ? soldOutText : addToCartText}</div>
</div>

<!--suppress CssUnresolvedCustomProperty -->
<style>
    .fast-upsell-btn-container {
        width: 100%;
        height: 40px;
        margin: 7px 0;
    }

    .fast-add-to-cart-button-upsell {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid gray;
        border-radius: 3px;
        transition: 200ms all ease-in-out;
        background-color: white;
        color: black;
    }

    .fast-add-to-cart-button-upsell:hover{
        background-color: black;
        color: white;
    }

    .fs-atc-so {
        pointer-events: none;
        cursor: default;
    }
</style>